"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ContentEditorUtils {
    removeToolbarFromDOM() {
        document
            .querySelectorAll('.redactor-toolbar-tooltip')
            .forEach((element) => {
            element.remove();
        });
    }
    removeRemainingElementsFromDOM() {
        this.removeToolbarFromDOM();
    }
}
exports.default = new ContentEditorUtils();
